import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import styles from "@/index.css?inline";
import EkoElement from "@/utilities/element";
import "@/components/block-list/block-list-item";
import style from "./block-list.css?inline";

@customElement("eko-block-list")
export class BlockList extends EkoElement {
  static styles = [unsafeCSS(styles), unsafeCSS(style)];

  @property({ reflect: true }) padding: "lg" | "md" | "sm" | "none" = "lg";
  @property({ reflect: true }) variant: "default" | "borderless" = "default";

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-block-list": BlockList;
  }
}

export default BlockList;
